export const ChatKeys = {
	all: ["chat"] as const,
	list: () => [...ChatKeys.all, "list", "v2"] as const,
	listSearch: (search: string) => [...ChatKeys.list(), search] as const,
	detail: (conversationId: number | null) =>
		[...ChatKeys.all, "detail", "v2", conversationId] as const,
	messages: (conversationId: number | null) =>
		[...ChatKeys.all, "messages", "v2", conversationId] as const,
	send: (conversationId: number | null) =>
		[...ChatKeys.all, "send", conversationId] as const,
	sendScope: (conversationId: number | null) =>
		`chat-send-${conversationId ?? "new"}`,
	attachment: (attachmentId: number) =>
		[...ChatKeys.all, "attachment", attachmentId] as const,
};
